import React from 'react'
import AccountPage from 'scenes/Account/AccountPage.component'
import { ChangePasswordForm } from 'scenes/Account/components/ChangePasswordForm'

class ChangePassword extends React.PureComponent {
  render() {
    return (
      <AccountPage title="Reset your password">
        <ChangePasswordForm />
      </AccountPage>
    )
  }
}

export default ChangePassword
